// collapse-menu

(function(Drupal, $, once) {
  Drupal.behaviors.collapse_menu = {
    attach: function (context, settings) {
      once(
        'clps',
        '.collapse-menu',
      ).forEach((menu_wrapper) => {

        let menus = menu_wrapper.querySelectorAll('ul.menu > li.nav-item:has(ul)');

        menus.forEach((menu,index) => {

          let auto_expand = menu_wrapper.getAttribute('data-auto-expand') === 'yes';

          let menu_id = menu_wrapper.getAttribute('data-menu-id');
          let id = `clps-${menu_id}-${index}`;

          menu.setAttribute('id', id);

          if (auto_expand) {
            if (!menu.classList.contains('menu-item--active-trail') && !menu.classList.contains('expanded')) {
              menu.classList.add('closed');
            } else {
              menu.classList.add('open');
            }
          }
          else {
            if (menu.classList.contains('expanded')) {
              menu.classList.add('open');
            } else {
              menu.classList.add('closed');
            }
          }


          let toggler = document.createElement('a');
          toggler.setAttribute('class', 'toggler');
          toggler.setAttribute('data-toggle', id);

          let top_link = menu.querySelector('span.nolink') || menu.querySelector('a.link');
          top_link.outerHTML = `<div class="menu-item">${toggler.outerHTML}${top_link.outerHTML}</div>`;

          menu.querySelector('.toggler').addEventListener('click', function(event) {
            let id = event.target.getAttribute('data-toggle');
            let menu = document.getElementById(id);
            let ul = menu.querySelector('ul');

            menu.classList.add('animating');

            if (menu.classList.contains('open')) {
              $(ul).slideUp(200, function() {
                menu.classList.remove('open');
                menu.classList.add('closed');
                menu.classList.remove('animating');
              });
            }
            else if (menu.classList.contains('closed')) {
              $(ul).slideDown(200, function() {
                menu.classList.remove('closed');
                menu.classList.add('open');
                menu.classList.remove('animating');
              });
            }

          });
        });





      });

    },
  };
})(Drupal, jQuery, once);
